import { memo, useState, FC } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { CheckArabicText, CheckEnglishText } from '../../utils';
import { LANGAUAGE } from '../../common/constants';
import { InlineIcon } from '@iconify/react/dist/iconify.js';
import { IField } from "./Field.type";

const Field: FC<IField> = ({ children, id, isMulti = false, label, value, setValue, type, min, name, className, placeholder, searchField, disabled, accept, lang = LANGAUAGE.Both }) => {

  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const handleChange = (event: any) => {
    if (event.target.value && type != 'file') {

      if (lang == LANGAUAGE.Arabic && !CheckArabicText(event.target.value)) {
        event.preventDefault()
        return toast.warning(t('Please Enter Arabic'))
      }
      if (lang == LANGAUAGE.English && !CheckEnglishText(event.target.value)) {
        event.preventDefault()
        return toast.warning(t('Please Enter English'))
      }
    }

    if (!searchField) {
      type != 'file' && setValue && setValue(event.target.value)
      type == 'file' && setValue && setValue(event.target)
      return
    }

    if (type != 'file') {
      const { value, name } = event.target
      setValue && setValue((prev: any[]) => prev.map((field: any) => field.label == name ? { ...field, value } : field))
    }

  };


  return (
    <div className={` form-group field-wrapper  ${className}`}  >
      {
        label ?

          <label htmlFor={id} className="field-label">
            {t(label)}
          </label>
          : ""}
      {children ||
        <>
          <input multiple={isMulti} accept={accept} disabled={disabled} className="form-control" name={name} min={min} type={showPassword ? "text" : type}
            id={id} value={value || ""} onChange={handleChange} placeholder={t(placeholder) || ''} />
          {type == "password" && (
            <InlineIcon className="end-of-field-icon" icon={`clarity:eye-${showPassword ? "show" : "hide"}-line`} onClick={() => setShowPassword((prev) => !prev)} />
          )}
        </>
      }
    </div>
  );
};

export default memo(Field);
